var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallCheckGreen = function SvgSmallCheckGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "info copy 2")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_Cashy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login_Form_Details",
    transform: "translate(-670.000000, -5191.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window-Copy",
    transform: "translate(299.000000, 4864.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Righ_Col",
    transform: "translate(360.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Form",
    transform: "translate(0.000000, 155.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pass_Check_#",
    transform: "translate(11.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info-copy-2",
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#31C46F",
    cx: 9.375,
    cy: 9.375,
    r: 9.375
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-39",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    points: "6 9.07701019 8.82862081 11.8950195 13 6.89501953"
  }))))))))));
};
export default SvgSmallCheckGreen;